import { Component, Input } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { ClipboardService } from '../../services/clipboard.service';

@Component({
  selector: 'app-copy-text',
  standalone: true,
  imports: [],
  templateUrl: './copy-text.component.html',
  styleUrl: './copy-text.component.scss'
})
export class CopyTextComponent {
  @Input() text: string = '';
  @Input() label: string = '';

  constructor(private clipboardService: ClipboardService, private notification: NzNotificationService) {}

  copyToClipboard(text: string): void {
    this.clipboardService.copyToClipboard(text);
    this.notification.success(
      'Copied to clipboard',
      '',
      { nzClass: 'notification' }
    );
  }
}
